import { useMemo } from 'react'
import sanitizeHtml from 'sanitize-html'

// Configuração padrão como constante
const DEFAULT_SANITIZE_OPTIONS = {
  parseStyleAttributes: false,
  allowedTags: [
    ...sanitizeHtml.defaults.allowedTags,
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'table',
    'thead',
    'tbody',
    'tr',
    'td',
    'th'
  ],
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    '*': ['style', 'class', 'href', 'target', 'rel']
  },
  transformTags: {
    p: (tagName, attribs) => ({
      tagName: 'div',
      attribs
    })
  },
  allowedSchemes: ['http', 'https', 'mailto']
}

export default function useSanitizeHtml(dirtyHtml, customOptions = {}) {
  return useMemo(() => {
    if (!dirtyHtml || typeof dirtyHtml !== 'string') return ''

    try {
      const options = {
        ...DEFAULT_SANITIZE_OPTIONS,
        ...customOptions,
        parseStyleAttributes: false
      }

      return sanitizeHtml(dirtyHtml, options)
    } catch (error) {
      console.error('Erro na sanitização HTML:', error)
      return ''
    }
  }, [dirtyHtml, customOptions])
}
